import { render, staticRenderFns } from "./ContaWindow.vue?vue&type=template&id=77cd770a"
import script from "./ContaWindow.vue?vue&type=script&lang=js"
export * from "./ContaWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports